const MiniProgram = {
  NAVIGATE_TO: 'navigateTo',
  NAVIGATE_BACK: 'navigateBack',
  REDIRECT_TO: 'redirectTo',
  SWITCH_TAB: 'switchTab',
  RE_LAUNCH: 'reLaunch',
  POST_MESSAGE: 'postMessage',
  CLOSE: 'close'
};

const Native = {
  CHOOSE_VIDEO: 'chooseVideo',
  CHOOSE_IMAGE: 'chooseImage',
  GET_LOCAL_IMG_DATA: 'getLocalImgData',
  GET_LOCATION: 'getLocation',
  PREVIEW_IMAGE: 'previewImage',
  OPEN_DOCUMENT: 'openDocument',
  GET_STORAGE: 'getStorage',
  SET_STORAGE: 'setStorage',
  GET_STORAGE_SYNC: 'getStorageSync',
  SET_STORAGE_SYNC: 'setStorageSync',
  REMOVE_STORAGE: 'removeStorage',
  CLEAR_STORAGE: 'clearStorage',
  GET_NETWORK_TYPE: 'getNetworkType',
  SCAN_CODE: 'scanCode',
  GET_STATUS_BAR_HEIGHT: 'getStatusBarHeight',
  CAPSULE_STYLE: 'capsuleStyle',
  HIDE_LOADING: 'hideLoading',
  SHOW_LOADING: 'showLoading',
  SHOW_TOAST: 'showToast',
  GET_SMALL_APP_INFO: 'getsmallappinfo',
  GO_TO_BROWSER: 'gotoBrowser',
  SAVE_FILE_TO_PHONE: 'saveFileToPhone',
  SAVE_IMAGE: 'saveImage',
  SAVE_BASE64_IMAGE: 'saveBase64Image',
  CHOOSE_CONTACT: 'chooseContact',
  IS_ONLINE: 'isOnline',
  REQUEST: 'request',
  UPLOAD_FILE: 'uploadFile',
  DOWNLOAD_FILE: 'downloadFile',
  REPORT_EVENT: 'reportEvent',
  REPORT_PERFORMANCE: 'reportPerformance',
  REPORT_LOG: 'reportLog',
  SUBMIT_REPORT: 'submitReport',
  PLAY_VOICE: 'playVoice',
  PLAY_AUDIO: 'playAudio',
  GET_BACKGROUND_FETCH_DATA: 'getBackgroundFetchData',
  GET_LAUNCH_OPTIONS_SYNC: 'getLaunchOptionsSync',
  GET_SYSTEM_INFO_SYNC: 'getSystemInfoSync',
  NAVIGATE_TO_MINI_PROGRAM: 'navigateToMiniProgram',
  EXIT_MINI_PROGRAM: 'exitMiniProgram',
  STOP_AUOID: 'stopVoice',
  GET_OPEN_USER_INFO: 'getOpenUserInfo',
  GET_AUTH_CODE: 'getAuthCode',
  OPEN_BLUETOOTH_ADAPTER: 'openBluetoothAdapter',
  CLOSE_BLUETOOTH_ADAPTER: 'closeBluetoothAdapter',
  START_BLUETOOTH_DEVICES_DISCOVERY: 'startBluetoothDevicesDiscovery',
  STOP_BLUETOOTH_DEVICES_DISCOVERY: 'stopBluetoothDevicesDiscovery',
  CREATE_BLE_CONNECTION: 'createBLEConnection',
  CLOSE_BLE_CONNECTION: 'closeBLEConnection',
  GET_BLE_DEVICE_SERVICES: 'getBLEDeviceServices',
  GET_BLE_DEVICE_CHARACTERISTICS: 'getBLEDeviceCharacteristics',
  READ_BLE_CHARACTERISTIC_VALUE: 'readBLECharacteristicValue',
  WRITE_BLE_CHARACTERISTIC_VALUE: 'writeBLECharacteristicValue',
  ON_BLUETOOTH_DEVICE_FOUND: 'ON_BT_DEVICE_FOUND',
  ON_SCREEN_RECORD_STATE_CHANGE: 'ON_SCREEN_RECORD_STATE_CHANGE',
  ON_KEYBOARD_HEIGHT_CHANGE: 'ON_KEYBOARD_HEIGHT_CHANGE',
  TRADE_PAY: 'tradePay',
  DEAUTHORIZE_PERMISSION: 'deauthorize',
  CANCLE_AUTHORIZE_PERMISSION: 'cancelAuthorize',
  GET_SYSTEM_SETTING: 'getSystemSetting',
  BASE64_TO_ARRAYBUFFER: 'base64ToArrayBuffer',
  GET_CLIPBOARD_DATA: 'getClipboardData',
  SET_CLIPBOARD_DATA: 'setClipboardData',
  SET_CAPSULE_SHOW: 'setCapsuleShow'
};

export const APINames = {
  MiniProgram,
  Native
};
